import { useBloc as useBlocNext } from "@blac/react";
import AuthenticationBloc, {
  AuthenticationStatus
} from "../UserCubit/AuthenticationBloc";
import { AuthStage } from "src/types/auth";

export interface UserAuthStageResult {
  authStage: AuthStage;
  authenticationStatus: AuthenticationStatus;
  credentialsRestored: boolean;
  sessionRestoreSettled: boolean;
  hasStoredCredentials: boolean;
}

/**
 * Read-only view of the auth stage. WithAuth is the single owner of refreshing
 * it — a hook-level effect would re-fetch the profile once per consumer.
 */
export default function useUserAuthStage(): UserAuthStageResult {
  const [
    {
      authStage,
      authenticationStatus,
      credentialsRestored,
      sessionRestoreSettled,
      hasStoredCredentials
    }
  ] = useBlocNext(AuthenticationBloc);

  return {
    authStage,
    authenticationStatus,
    credentialsRestored,
    sessionRestoreSettled,
    hasStoredCredentials
  };
}
